import React from 'react';
import {makeStyles} from '@material-ui/core';
import {designTokens} from '../../styles/designTokens';

const useStyles = makeStyles({
  scrollWrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',
    maxHeight: '100%',
  },
  scrollContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    maxHeight: '100%',
    overflow: 'auto',
    scrollbarWidth: 'none',
    padding: `0 ${designTokens.spacing.lg} ${designTokens.spacing.lg}`,
    '@media (max-width: 640px)': {
      padding: `0 ${designTokens.spacing.sm} ${designTokens.spacing.sm}`,
    },
  },
});

export default function ScrollContainer({ children }) {
  const classes = useStyles();
  return (
    <div className={classes.scrollWrapper}>
      <div className={classes.scrollContainer}>{children}</div>
    </div>
  );
}
